import { render, staticRenderFns } from "./CrmLayoutIframe.vue?vue&type=template&id=072fb77a&"
import script from "./CrmLayoutIframe.vue?vue&type=script&lang=ts&"
export * from "./CrmLayoutIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports